export default "__VITE_ASSET__8a83a700__"